import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { StyledNumberBadge } from "./NumberBadge.style";
import useWindowSize from "../../../../hooks/layout/useWindowSize";
const NumberBadge = ({ value, variant, lockMobile = false, ...props }) => {
    const { width } = useWindowSize();
    const [isMobile, setIsMobile] = useState(true);
    useEffect(() => {
        const isMobile = width <= 1024;
        setIsMobile(isMobile);
    }, [width]);
    return (_jsx(StyledNumberBadge, { isMobile: lockMobile || isMobile, variant: variant, ...props, children: value }));
};
export default NumberBadge;
//# sourceMappingURL=NumberBadge.js.map